export const buildSteps = [
  { id: 1, label: 'Analyzing Prompt', icon: 'Brain' },
  { id: 2, label: 'Designing UI', icon: 'Palette' },
  { id: 3, label: 'Generating Code', icon: 'Code' },
  { id: 4, label: 'Building Apps', icon: 'Smartphone' },
  { id: 5, label: 'Deploying Preview', icon: 'Rocket' }
];

export const buildHistory = [
  {
    id: '1',
    prompt: 'E-commerce platform with real-time inventory and payment gateway',
    status: 'success',
    timestamp: '2025-01-15T10:30:00Z',
    duration: '2m 45s'
  },
  {
    id: '2',
    prompt: 'Social media dashboard with analytics and user engagement metrics',
    status: 'in_progress',
    timestamp: '2025-01-15T09:15:00Z',
    duration: '1m 20s'
  },
  {
    id: '3',
    prompt: 'AI-powered fitness tracker with personalized workout plans',
    status: 'success',
    timestamp: '2025-01-14T16:45:00Z',
    duration: '3m 10s'
  },
  {
    id: '4',
    prompt: 'Real estate listing platform with virtual tours',
    status: 'failed',
    timestamp: '2025-01-14T14:20:00Z',
    duration: '0m 45s'
  },
  {
    id: '5',
    prompt: 'Recipe sharing app with ingredient tracking',
    status: 'success',
    timestamp: '2025-01-13T11:00:00Z',
    duration: '2m 30s'
  }
];

export const downloads = [
  {
    id: 'web-source',
    title: 'Website Source Code',
    description: 'Complete React + Node.js codebase',
    icon: 'Code',
    format: 'ZIP',
    size: '12.5 MB'
  },
  {
    id: 'admin-source',
    title: 'Admin Panel Source Code',
    description: 'Full-featured admin dashboard',
    icon: 'LayoutDashboard',
    format: 'ZIP',
    size: '8.3 MB'
  },
  {
    id: 'android-apk',
    title: 'Android APK',
    description: 'Ready to install on devices',
    icon: 'Smartphone',
    format: 'APK',
    size: '45.2 MB'
  },
  {
    id: 'android-aab',
    title: 'Android AAB',
    description: 'Google Play Store bundle',
    icon: 'Package',
    format: 'AAB',
    size: '38.7 MB'
  },
  {
    id: 'ios-ipa',
    title: 'iOS IPA',
    description: 'iOS app package for TestFlight',
    icon: 'Apple',
    format: 'IPA',
    size: '52.1 MB'
  }
];

export const previews = [
  {
    id: 'website',
    title: 'Website Preview',
    description: 'Live preview of your generated website',
    url: 'https://preview.example.com/website',
    thumbnail: 'https://images.unsplash.com/photo-1659841064804-5f507b1b488a?auto=format&fit=crop&w=800&q=80',
    status: 'ready'
  },
  {
    id: 'admin',
    title: 'Admin Panel Preview',
    description: 'Full-featured admin dashboard',
    url: 'https://preview.example.com/admin',
    thumbnail: 'https://images.unsplash.com/photo-1617783919255-b36e439deeda?auto=format&fit=crop&w=800&q=80',
    status: 'ready'
  }
];
